import { Add } from './Math/Add';
import { Subtract } from './Math/Subtract';
import { If } from './FlowControl/If';
import { Multiply } from './Math/Multiply';
import { Divide } from './Math/Divide';
import { Modulo } from './Math/Modulo';
import { MergeText } from './Text/MergeText';
import { TextPrimitive } from './Text/TextPrimitive';
import { NumberToText } from './Conversion/NumberToText';
import { Node } from '@glueapp/graph-types';
import { ReplaceInText } from './Text/ReplaceInText';
import { ToLowerCase } from './Text/ToLowerCase';
import { ToUpperCase } from './Text/ToUpperCase';
import { Trim } from './Text/Trim';
import { TrimStart } from './Text/TrimStart';
import { TrimEnd } from './Text/TrimEnd';
import { SplitText } from './Text/SplitText';
import { And } from './Logic/And';
import { ExclusiveOr } from './Logic/ExclusiveOr';
import { Or } from './Logic/Or';
import { GreaterThan } from './Comparison/GreaterThan';
import { GreaterThanOrEqual } from './Comparison/GreaterThanOrEqual';
import { LessThan } from './Comparison/LessThan';
import { LessThanOrEqual } from './Comparison/LessThanOrEqual';
import { Equal } from './Comparison/Equal';
import { UnEqual } from './Comparison/UnEqual';
import { BooleanToNumber } from './Conversion/BooleanToNumber';
import { GetLengthOfList } from './List/GetLengthOfList';
import { Not } from './Logic/Not';
import { AddItemToList } from './List/AddItemToList';
import { ObjectPrimitive } from './Object/ObjectPrimitive';
import { HttpRequest } from './Http/HttpRequest';
import { NumberPrimitive } from './Math/Number';
import { SelectItemFromList } from './List/SelectItemFromList';
import { RandomNumber } from './Math/RandomNumber';
import { ForEachItemInList } from './List/ForEachItemInList';
import { FunctionNode } from './Functions/FunctionNode';
import { CreateList } from './List/CreateList';
import { CreateListOfCopies } from './List/CreateListOfCopies';
import { BuildList } from './List/BuildList';
import { TextToNumber } from './Conversion/TextToNumber';
import { ListOfWordsFromText } from './Text/ListOfWordsFromText';
import { Round } from './Math/Round';
import { Floor } from './Math/Floor';
import { Ceil } from './Math/Ceil';
import { JoinTextList } from './Text/JoinTextList';
import { GetRandomItemFromList } from './List/GetRandomItemFromList';
import { SortListAlphabetically } from './List/SortListAlphabetically';
import { SortListOfNumbers } from './List/SortListOfNumbers';
import { ReverseList } from './List/ReverseList';
import { FilterList } from './List/FilterList';
import { TextLength } from './Text/TextLength';
import { FilterMapList } from './List/FilterMapList';
import { GetTodoistProjects } from './Integrations/Todoist/GetTodoistProjects';
import { AddTodoistTask } from './Integrations/Todoist/AddTodoistTask';
import { GetObjectProperties } from './Object/GetObjectProperties';
import { ConvertToJSON } from './JSON/ConvertToString';
import { ParseJSON } from './JSON/ParseJSON';
import { GetVariable } from './Variables/GetVariable';
import { SetVariable } from './Variables/SetVariable';
import { GetAllFiles } from './Integrations/Google/GoogleDrive/GetAllFiles';
import { GetSpreadsheet } from './Integrations/Google/GoogleDrive/GetSpreadsheet';
import { EqualText } from './Text/EqualText';
import { ManualTrigger } from './Triggers/ManualTrigger';
import { Webhook } from './Triggers/Webhook';
import { Comparison } from './Comparison/Comparison';
import { SplitPath } from './FlowControl/SplitPath';
import { LogToConsole } from './Logging/LogToConsole';
import { BooleanPrimitive } from './Logic/Boolean';
import { AbsoluteValue } from './Math/AbsoluteValue';
import { Clamp } from './Math/Clamp';
import { E } from './Math/E';
import { PI } from './Math/PI';
import { Logarithm10 } from './Math/Logarithm10';
import { NaturalLogarithm } from './Math/NaturalLogarithm';
import { Maximum } from './Math/Maximum';
import { Minimum } from './Math/Minimum';
import { SquareRoot } from './Math/SquareRoot';
import { Sine } from './Math/Sine';
import { HyperbolicCosine } from './Math/HyperbolicCosine';
import { HyperbolicSine } from './Math/HyperbolicSine';
import { HyperbolicTangent } from './Math/HyperbolicTangent';
import { Cosine } from './Math/Cosine';
import { Tangent } from './Math/Tangent';
import { TextTemplate } from './Text/TextTemplate';
import { Switch } from './FlowControl/Switch';
import { SendSlackMessage } from './Integrations/Slack/SendSlackMessage';
import { GetSlackChannels } from './Integrations/Slack/GetSlackChannels';
import { SlackMessageReceived } from './Integrations/Slack/SlackMessageReceived';
import { LoadFile } from './File/LoadFile';
import { SlackFileShared } from './Integrations/Slack/SlackFileShared';
import { GMailSearchEmails } from './Integrations/Google/GoogleMail/SearchEmails';
import { GetGmailEmailById } from './Integrations/Google/GoogleMail/GetEmail';
import { GMailGetEmailsInInbox } from './Integrations/Google/GoogleMail/GetEmailsInInbox';
import { ListContains } from './List/ListContains';
import { GmailRemoveLabelFromEmail } from './Integrations/Google/GoogleMail/RemoveLabelFromEmail';
import { FindInList } from './List/FindInList';
import { GeneratedNodes_Github } from './Integrations/Github/GeneratedGithubNodes';
import { NullPrimitive } from './Object/NullPrimitive';
import { IsNull } from './Comparison/IsNull';
import { GetIfNotNull } from './Object/GetIfNotNull';
import { DefaultForOptional } from './Object/DefaultForOptional';
import { Unpack } from './Object/Unpack';
import { GeneratedNodes_Okta } from './Integrations/Okta/OktaGeneratedNodes';
import { Schedule } from './Triggers/Schedule';
import { FormTrigger } from './Triggers/FormTrigger';
import { ApiServer } from './Triggers/ApiServer';
import { RespondToApi } from './Actions/RespondToApi';
import { RespondToApiStream } from './Actions/RespondToApiStream';
import { ParseBasicAuth } from './APIServer/ParseBasicAuth';
import { ParseBearerToken } from './APIServer/ParseBearerToken';
import { CheckApiKey } from './APIServer/CheckApiKey';
import { CheckPassword } from './APIServer/CheckPassword';
import { HashPassword } from './APIServer/HashPassword';
import { FunctionInputsNode } from './Functions/FunctionInputsNode';
import { FunctionOutputsNode } from './Functions/FunctionOutputsNode';
import { GetSecret } from './Secrets/GetSecret';
import { DynamicGetSecret } from './Secrets/DynamicGetSecret';

// Date & Time - Construction
import { DateNode } from './DateTime/Date';
import { TimeNode } from './DateTime/Time';
import { DateTimeNode } from './DateTime/DateTime';
import { ZonedDateTimeNode } from './DateTime/ZonedDateTime';
import { DurationNode } from './DateTime/Duration';
import { InstantNode } from './DateTime/Instant';

// Date & Time - Now
import { NowDate } from './DateTime/NowDate';
import { NowTime } from './DateTime/NowTime';
import { NowDateTime } from './DateTime/NowDateTime';
import { NowZonedDateTime } from './DateTime/NowZonedDateTime';
import { NowInstant } from './DateTime/NowInstant';
import { SystemTimezone } from './DateTime/SystemTimezone';

// Date & Time - Parse
import { ParseDate } from './DateTime/ParseDate';
import { ParseTime } from './DateTime/ParseTime';
import { ParseDateTime } from './DateTime/ParseDateTime';
import { ParseZonedDateTime } from './DateTime/ParseZonedDateTime';
import { ParseDuration } from './DateTime/ParseDuration';

// Date & Time - Arithmetic
import { AddDuration } from './DateTime/AddDuration';
import { SubtractDuration } from './DateTime/SubtractDuration';
import { DurationBetween } from './DateTime/DurationBetween';
import { AddDurations } from './DateTime/AddDurations';
import { SubtractDurations } from './DateTime/SubtractDurations';
import { NegateDuration } from './DateTime/NegateDuration';
import { TotalDuration } from './DateTime/TotalDuration';

// Date & Time - Comparison
import { CompareDateTime } from './DateTime/CompareDateTime';
import { CompareDurations } from './DateTime/CompareDurations';

// Date & Time - Conversion
import { DateToDateTime } from './DateTime/DateToDateTime';
import { DateTimeToDate } from './DateTime/DateTimeToDate';
import { DateTimeToTime } from './DateTime/DateTimeToTime';
import { DateTimeToZonedDateTime } from './DateTime/DateTimeToZonedDateTime';
import { ZonedDateTimeToDateTime } from './DateTime/ZonedDateTimeToDateTime';
import { ZonedDateTimeToInstant } from './DateTime/ZonedDateTimeToInstant';
import { InstantToZonedDateTime } from './DateTime/InstantToZonedDateTime';
import { ChangeTimezone } from './DateTime/ChangeTimezone';

// Date & Time - Extraction
import { GetDateInfo } from './DateTime/GetDateInfo';
import { GetTimeInfo } from './DateTime/GetTimeInfo';

// Date & Time - Format
import { FormatDateTime } from './DateTime/FormatDateTime';
import { FormatDuration } from './DateTime/FormatDuration';
import { FormatDateTimePattern } from './DateTime/FormatDateTimePattern';
import { FormatDurationPattern } from './DateTime/FormatDurationPattern';

// Date & Time - Modify
import { SetDateComponents } from './DateTime/SetDateComponents';
import { SetTimeComponents } from './DateTime/SetTimeComponents';

export const NODE_LIBRARY: Node[] = [
    // Function System (internal nodes, not visible in UI)
    FunctionInputsNode,
    FunctionOutputsNode,

    // Functions
    FunctionNode,

    // Triggers
    ManualTrigger,
    Webhook,
    Schedule,
    FormTrigger,

    // API Server
    ApiServer,
    RespondToApi,
    RespondToApiStream,
    ParseBasicAuth,
    ParseBearerToken,
    CheckApiKey,
    CheckPassword,
    HashPassword,

    // Variables
    GetVariable,
    SetVariable,

    // Secrets
    GetSecret,
    DynamicGetSecret,

    // Logging,
    LogToConsole,

    // List
    GetLengthOfList,
    AddItemToList,
    SelectItemFromList,
    CreateList,
    CreateListOfCopies,
    BuildList,
    GetRandomItemFromList,
    SortListAlphabetically,
    SortListOfNumbers,
    ReverseList,
    FilterList,
    FilterMapList,
    ListContains,
    FindInList,

    // Object
    Unpack,
    ObjectPrimitive,
    GetObjectProperties,
    // SetObjectProperties,
    NullPrimitive,
    GetIfNotNull,
    DefaultForOptional,

    // JSON
    ConvertToJSON,
    ParseJSON,

    // Math
    NumberPrimitive,
    AbsoluteValue,
    Maximum,
    Minimum,
    Clamp,
    E,
    PI,
    NaturalLogarithm,
    Logarithm10,
    Add,
    Subtract,
    Multiply,
    Divide,
    Sine,
    Cosine,
    Tangent,
    HyperbolicCosine,
    HyperbolicSine,
    HyperbolicTangent,
    SquareRoot,
    Modulo,
    RandomNumber,
    Round,
    Floor,
    Ceil,

    // Logic
    BooleanPrimitive,
    And,
    ExclusiveOr,
    Or,
    Not,

    // Comparison
    IsNull,
    Comparison,
    GreaterThan,
    GreaterThanOrEqual,
    LessThan,
    LessThanOrEqual,
    Equal,
    UnEqual,

    // FlowControl
    If,
    ForEachItemInList,
    SplitPath,
    Switch,

    // HTTP
    HttpRequest,

    // Conversion
    NumberToText,
    BooleanToNumber,
    TextToNumber,

    // Text
    EqualText,
    MergeText,
    ReplaceInText,
    TextPrimitive,
    ToLowerCase,
    ToUpperCase,
    Trim,
    TrimStart,
    TrimEnd,
    SplitText,
    JoinTextList,
    ListOfWordsFromText,
    TextLength,
    TextTemplate,

    // File
    LoadFile,

    // Date & Time
    DateNode,
    TimeNode,
    DateTimeNode,
    ZonedDateTimeNode,
    DurationNode,
    InstantNode,
    NowDate,
    NowTime,
    NowDateTime,
    NowZonedDateTime,
    NowInstant,
    SystemTimezone,
    ParseDate,
    ParseTime,
    ParseDateTime,
    ParseZonedDateTime,
    ParseDuration,
    AddDuration,
    SubtractDuration,
    DurationBetween,
    AddDurations,
    SubtractDurations,
    NegateDuration,
    TotalDuration,
    CompareDateTime,
    CompareDurations,
    DateToDateTime,
    DateTimeToDate,
    DateTimeToTime,
    DateTimeToZonedDateTime,
    ZonedDateTimeToDateTime,
    ZonedDateTimeToInstant,
    InstantToZonedDateTime,
    ChangeTimezone,
    GetDateInfo,
    GetTimeInfo,
    FormatDateTime,
    FormatDuration,
    FormatDateTimePattern,
    FormatDurationPattern,
    SetDateComponents,
    SetTimeComponents,

    /////////////////////////////////////////////////////////////
    //////////////////////   Integrations   /////////////////////
    /////////////////////////////////////////////////////////////

    // Slack
    GetSlackChannels,
    SendSlackMessage,
    SlackMessageReceived,
    SlackFileShared,

    // Todoist
    GetTodoistProjects,
    AddTodoistTask,

    // Google Drive
    GetAllFiles,
    GetSpreadsheet,

    // Gmail
    GMailGetEmailsInInbox,
    GMailSearchEmails,
    GetGmailEmailById,
    GmailRemoveLabelFromEmail,

    // Github
    ...GeneratedNodes_Github,
    // Okta
    ...GeneratedNodes_Okta,

    // Google Calendar
    // GetCalendars,
    // GoogleCalendar
];

export const NODE_LIBRARY_DICTIONARY = NODE_LIBRARY.reduce((acc: { [key: string]: Node }, element) => {
    acc[element.id] = element;
    return acc;
}, {});
